import { useLayoutEffect, useMemo, useRef, useState } from "react";
import type { OrbMessage } from "./types";

const MAX_MESSAGES = 6;

function getMessagesId(messages: OrbMessage[]) {
  return messages.map(m => m.id).join(",");
}

export function useMessageLayout(rawMessages: OrbMessage[]) {
  const sliced = rawMessages.slice(-MAX_MESSAGES);
  const messagesId = getMessagesId(sliced);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const messages = useMemo(() => sliced, [messagesId]);

  const [layoutKey, setLayoutKey] = useState(0);
  const [messagesInitial, setMessagesInitial] = useState(false);
  const initialMessages = useRef(messages);

  useLayoutEffect(() => {
    const initialMessagesId = getMessagesId(initialMessages.current);
    if (messagesId !== initialMessagesId) {
      setMessagesInitial(true);
    }

    setLayoutKey(prev => (messages.length === 1 ? prev + 1 : prev));
  }, [messagesId, messages.length]);

  return { messages, layoutKey, messagesInitial };
}
